import * as React from 'react';
import classnames from 'classnames';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import styles from './Zoom.styl';
export const Zoom = (props) => {
    const { handleZoomOutClick, handleZoomInClick, zoomLevel, maxZoomLevel, minZoomLevel } = props;
    const zoomOutClassNames = classnames(styles.zoomOutWrapper, { [styles.disabled]: zoomLevel === minZoomLevel });
    const zoomInClassNames = classnames(styles.zoomInWrapper, { [styles.disabled]: zoomLevel === maxZoomLevel });
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: zoomOutClassNames, onClick: handleZoomOutClick },
            React.createElement(IconSVG, { name: 'zoomOut', customDimensions: true, className: styles.zoomOut })),
        React.createElement("div", { className: zoomInClassNames, onClick: handleZoomInClick },
            React.createElement(IconSVG, { name: 'zoomIn', customDimensions: true, className: styles.zoomIn }))));
};
